import React, {forwardRef} from 'react';
import styled from 'styled-components';

import {InteractionComponentProps} from '../../../../libs/shared/helpers/src/interaction/interactionHelpers';
import {
  BoxedInput,
  BoxedInputInheritableProps,
} from '../../../../libs/shared/ui/src/components/boxedInputs/boxedInput';
import {
  BoxedInputElement,
  BoxedInputElementInheritableProps,
  BoxedInputElementTypesEnum,
} from '../../../../libs/shared/ui/src/components/boxedInputs/boxedInputElement';
import {BoxedInputIcon} from '../../../../libs/shared/ui/src/components/boxedInputs/boxedInputIcon';
import {IconName} from '../../../../libs/shared/ui/src/components/icon/icon';

/*
 * Props.
 */

export interface IconTextBoxProps
  extends BoxedInputInheritableProps,
    BoxedInputElementInheritableProps,
    InteractionComponentProps {
  noMargin?: boolean;
  iconName: IconName;
}

/*
 * Styles.
 */

const StyledSearchInputElement = styled(BoxedInputElement)`
  margin-left: 0;
`;

/*
 * Component.
 */

/** Basic text input. */
export const IconTextBox = forwardRef<BoxedInput, IconTextBoxProps>((props, ref) => (
  <BoxedInput {...props} ref={ref}>
    {(childProps) => {
      const {iconName} = props;

      return (
        <>
          <BoxedInputIcon {...childProps} iconName={iconName} />
          <StyledSearchInputElement {...childProps} {...props} type={BoxedInputElementTypesEnum.TEXT} />
        </>
      );
    }}
  </BoxedInput>
));
